import { NgModule } from '@angular/core';
import { VerticalNavigationComponent } from '@app/lib/b2b-components/b2b-navigation/vertical-navigation/vertical-navigation.component';
import { SharedModule } from '@app/lib/shared/shared.module';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [VerticalNavigationComponent],
  imports: [SharedModule, RouterModule],
  exports: [VerticalNavigationComponent],
})
export class B2bNavigationModule {}
